import { NumberSelectionSummary } from '@Components/ticket-list/number-selection-summary/number-selection-summary'
import { ListViewMatchDetails } from '@Components/ticket-list/list-view/list-view'
import { AddOnDetails } from '@Components/ticket-list/ticket-form-summary/ticket-form-summary'

import './styles.scss'
import { LoadingAnimation } from '@Components/loading/loading'
import { useCallback } from 'react'
import { AwaitingNextDrawCountdown } from './draw-countdown'
import { MultiplierAddOnResult } from '@Config/draw-results-types'
import { StaticAnimationModal } from '../animation-modal/static-animation-modal'
import { useSelector } from 'react-redux'
import { RootState } from '@AppState/redux-store'
import { Utils } from '@Util/utils'

const CLASS_NAME = 'gby-k2g-animation-awaiting-next-draw'

export type AwaitingNextDrawModalProps = {
  addOnDetails: AddOnDetails[]
  drawingNumber: number
  latestDrawNumber: number
  matchDetails: ListViewMatchDetails[]
  multiplierAddOnResult: MultiplierAddOnResult | undefined
  playerSelectedNumbers: number[] //TODO: Remove, probably?
}

export const AwaitingNextDrawModal = ({
  addOnDetails,
  drawingNumber,
  latestDrawNumber,
  matchDetails,
  multiplierAddOnResult,
}: AwaitingNextDrawModalProps) => {
  const hostConfig = useSelector((state: RootState) => state.hostConfig.config)
  const renderMultiplier = useCallback(
    (multiplierResult: MultiplierAddOnResult | undefined) => {
      if (multiplierResult === undefined) return null

      const valueString = Utils.getMultiplierDisplayValue(
        multiplierResult.value,
        hostConfig?.multiplierConfig.noMultiplierDisplayString,
      )

      return (
        <div className={`${CLASS_NAME}__value-section`}>
          <div className={`${CLASS_NAME}__label`}>{multiplierResult.name}:</div>
          <div className={`${CLASS_NAME}__value`}>{valueString}</div>
        </div>
      )
    },
    [hostConfig?.multiplierConfig.noMultiplierDisplayString],
  )
  const renderTopArea = useCallback(() => {
    if (matchDetails.length === 0) {
      return (
        <AwaitingNextDrawCountdown drawingNumber={drawingNumber} latestDraw={latestDrawNumber} />
      )
    }

    return (
      <>
        <div className={`${CLASS_NAME}__value-section`}>
          <div
            className={`${CLASS_NAME}__label`}>{`${hostConfig?.animationDrawInfo.awaitingNextDrawPreviousResultsLabel ?? 'Drawing'}:`}</div>
          <div className={`${CLASS_NAME}__value`}>{drawingNumber}</div>
        </div>

        <div className={`${CLASS_NAME}__number-section`}>
          <NumberSelectionSummary
            numberSelections={matchDetails}
            addOnDetails={addOnDetails}
            className={`${CLASS_NAME}__number-group`}
            numbersPerRow={5}
          />
        </div>

        {renderMultiplier(multiplierAddOnResult)}
      </>
    )
  }, [
    drawingNumber,
    latestDrawNumber,
    matchDetails,
    addOnDetails,
    multiplierAddOnResult,
    hostConfig?.animationDrawInfo.awaitingNextDrawPreviousResultsLabel,
    renderMultiplier,
  ])

  const renderFooter = useCallback(() => {
    return (
      <div className={`${CLASS_NAME}__footer`}>
        <div className={`${CLASS_NAME}__title`}>
          {hostConfig?.animationDrawInfo.awaitingNextDrawLabel ?? 'Awaiting Next Draw'}
        </div>
        <div className={`${CLASS_NAME}__loading`}>
          <LoadingAnimation />
        </div>
      </div>
    )
  }, [hostConfig?.animationDrawInfo.awaitingNextDrawLabel])

  return (
    <StaticAnimationModal
      title={hostConfig?.animationDrawInfo.awaitingNextDrawLabel ?? 'Awaiting Next Draw'}
      description={hostConfig?.animationDrawInfo.awaitingNextDrawLabel ?? 'Awaiting Next Draw'}
      footer={renderFooter()}>
      <div className={`${CLASS_NAME}`}>{renderTopArea()}</div>
    </StaticAnimationModal>
  )
}
